import * as React from "react";
import { SVGProps } from "react";
const SvgFolderCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    {...props}
  >
    <path d="M120-144q-29 0-50.5-21.5T48-216v-480h72v480h648v72H120Zm144-144q-29 0-50.5-21.5T192-360v-432q0-29.7 21.5-50.85Q235-864 264-864h169l96 96h263q29.7 0 50.85 21.15Q864-725.7 864-696v336q0 29-21.15 50.5T792-288H264Zm0-72h528v-336H500l-96-96H264v432Zm0 0v-432 432Z" />
  </svg>
);
export default SvgFolderCopy;
